import React from 'react';
import SimpleResourceLandingLayout from '../../components/layouts/SimpleResourceLandingLayout';

export const CustomerAccounting = () => {
  return (
    <SimpleResourceLandingLayout
      resourceName="accouting"
      tradKey="accounting"
      columns={[]}
      withCreateButton={false}
    />
  );
};
